const gql = String.raw;
  
export const Event = gql`
query EventBySlugQuery($slug: ID!) {
  eventBySlug(slug: $slug) {
    id slug name path typeLabel __typename _schema { label pluralLabel }
    startDate
    endDate
    isVirtual
    url
    overview { id text }
    description { id text }
    type { id name slug }
    types { id name slug __typename }
    color { id value darkValue }
    openGraph { image { thumbnails { full { url url2x } mainBanner { url url2x } } } }
    images { image { id url url2x width height } }
    roles { id name slug 
      role { id name }
      person {
        id name slug path __typename
        organisation { id name slug }
        position
        openGraph { image { thumbnails { bubble { url url2x } } } }
      }
    }
    banner {
      id name slug title description { text } alternateText
      image { 
        id url url2x width height thumbnails { halfBanner { url url2x } }
      }
    }
    location { id name country { id name } }
    links { id url name label isDownload page { path } }
    embeds {
      imageAssets {
        id
        slug
        image {
          id url url2x width height 
        }
      }
      fileAssets {
        id slug name __typename
        file {
          id url formattedSize typeName
        }
        openGraph {
          id image { url url2x }
        }
      }
    }
    sessions { 
      id name __typename 
      startDate endDate
      endDateTimeZone { label utcOffset abbreviation }
      startDateTimeZone { label utcOffset abbreviation }
      description { text }
      room { id name shortName }
      firstVenue { id name slug shortName }
      color { id veryLightValue lightValue value darkValue }
      presenters { 
        id name __typename slug path
        bio { html }
        photo { url url2x }
        position
        organisation { id name slug }
        openGraph { title description { plain } image { url url2x thumbnails { bubble { url url2x } } } }
      }
      presentingOrganisations { 
        id name __typename slug path
        description { html }
        logo { url url2x }
        openGraph { title description { plain } image { url url2x thumbnails { bubble { url url2x } } } }
      }
      group { id name shortName }
    }
  }
}
`;
